import { render, staticRenderFns } from "./Uncollected.vue?vue&type=template&id=7e621cdf&"
import script from "./Uncollected.vue?vue&type=script&lang=js&"
export * from "./Uncollected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports